import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Menubar from "./Menubar";
import MenubarMob from "./MenubarMob";

const Topnav = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <link rel="canonical" href={window.location.href} />
      {isMobile ? <MenubarMob /> : <Menubar />}
    </>
  );
};

export default Topnav;
